
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venue/[venueId]/new-reservation",
      function () {
        return require("private-next-pages/venue/[venueId]/new-reservation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venue/[venueId]/new-reservation"])
      });
    }
  